module.exports = __webpack_public_path__ + "img/contact.68e57a91.jpg";